import styled, { css } from 'styled-components'
import typography, { ParagraphTypes } from '../../../theme/basic/typography'

interface CheckBoxProps {
  isChecked?: boolean
  disabled?: boolean
  hasError?: boolean
}

interface WrapperProps {
  isChecked?: boolean
}

export const CheckMarkWrapper = styled.label<WrapperProps>`
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  padding: 0px 15px;
  border-radius: 4px;
  height: 50px;

  ${({ isChecked }) => (isChecked ?? false) &&
    css`
        background-color: #efeffd78;
  `}
`

export const StyledLabel = styled.div<CheckBoxProps>`
    ${typography[ParagraphTypes.PARAGRAPH_1]};
    display: block;
    margin-left: 1rem;

  ${({ disabled }) => (disabled ?? false) &&
    css`
        color: ${({ theme }) => theme.COLOR.NEUTRAL_GREY_3};
    `}
`

export const StyledInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`

export const StyledCheckMark = styled.div<CheckBoxProps>`
  position: relative;
  width: 2.2rem;
  height: 2.2rem;
  aspect-ratio: 1;
  border: 1px solid ${({ theme }) => theme.COLOR.NEUTRAL_GREY_4};
  background-color: ${({ theme }) => theme.COLOR.PRIMARY_WHITE};
  border-radius: 2px;

  &:hover {
    border-color: ${({ theme }) => theme.COLOR.PRIMARY_BLUE};
  }

  &::after {
    position: absolute;
    content: "";
    left: 50%;
    top: 50%;
    width: 35%;
    height: 65%;
    border: solid ${({ theme }) => theme.COLOR.PRIMARY_WHITE};
    border-width: 0 1px 1px 0;
    transform: translate(-50%, -60%) rotate(45deg);
    display: none;
  }

  ${({ hasError }) => (hasError ?? false) &&
    css`
      border-color: ${({ theme }) => theme.COLOR.SUPPORT_INVALID};
      color: ${({ theme }) => theme.COLOR.SUPPORT_INVALID};
      box-shadow: 0 0 0 1px ${({ theme }) => theme.COLOR.SUPPORT_INVALID};

      &:focus {
        box-shadow: 0 0 0 1px ${({ theme }) => theme.COLOR.SUPPORT_INVALID};
      }
  `};

  ${({ disabled }) => (disabled ?? false) &&
    css`
        border: 1px solid ${({ theme }) => theme.COLOR.NEUTRAL_GREY_3};
    `}

  ${({ isChecked, disabled }) => ((isChecked ?? false) && !(disabled ?? false)) &&
    css`
      background-color: ${({ theme }) => theme.COLOR.PRIMARY_BLUE};
      border-color: ${({ theme }) => theme.COLOR.PRIMARY_BLUE};

      &::after {
        display: block;
      }
    `}
`
